import React, { FunctionComponent, useState } from "react";
import {
    Modal,
    PrimaryButton,
    IconButton
} from "@fluentui/react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
    contentStyles as content,
    iconButtonStyles,
    cancelIcon,
} from "constants/styles";
import { CustomFontText } from "components/customFontText/CustomFontText";
import { Col, Row } from "react-grid-system";

const contentStyles = content(600, "auto");

interface IProps {
    onDismiss: () => void;
    isOpen: boolean;
    handleSelectLead: (data: any) => void;
    customernamaeList: any
}

export const MultipleCustLeadFoundDialog: FunctionComponent<IProps> = ({
    onDismiss,
    isOpen,
    handleSelectLead,
    customernamaeList
}) => {

    const [selectedLead, setSelectedLead] = useState(null);

    const handleSelect = () => {
        if (selectedLead) {
            handleSelectLead(selectedLead);
        }
    };


    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container + " custom-modal"}
            className="vehicleFoundDialog"
        >
            <div className={contentStyles.header + " inventory-popup"}>
                {/*<GoBackToMainDialogBtn label="" onClick={onDismiss} />*/}
                <CustomFontText className="formTitle">Multiple Leads Found
                </CustomFontText>

                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            <div className="leadNotFound body-auto-hight body-min-height-50">
                <div style={{ marginLeft: "25px", textAlign: "left" }}>
                    <label className="lbl-text">Please select lead to import.</label>
                </div>
                <div style={{ marginLeft: "25px",marginTop:'-7px', textAlign: "left" }}>
                    {customernamaeList.map((lead, index) => (
                        <Row>
                            <Col style={{ marginTop: '15px' }}
                            >
                                <label key={index} style={{display:'flex'}} className="radio-option" onClick={() => setSelectedLead(lead?.leadId)}>
                                    <input
                                        type="radio"
                                        name="lead"
                                        value={lead}
                                        checked={lead?.leadId ===selectedLead}
                                        onChange={(e) => setSelectedLead(lead?.leadId)}
                                        style={{ marginRight: "10px" }}
                                    />
                                    <div style={{marginTop:'-1px'}}>
                                         {`${lead?.customer.firstName} ${lead?.customer.lastName} `}
                                    </div>
                                </label>
                            </Col>
                        </Row>
                    ))}
                </div>
            </div>


            <div className={contentStyles.footer + " inventory-popup-footer"} >
                <Row className="inventoryRowSection footerBtn cusNoNotFoundFoot">
                    <Col style={{ display: "flex", justifyContent: 'center' }}>
                        <PrimaryButton
                            text="Select Lead"
                            disabled={!selectedLead}
                            onClick={handleSelect}
                            className=" cusNoNotFoundDiaBtnHeight"
                        />
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};



